import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = [ "form", "submitButton", "filterField", "coordinatesLatitude", "coordinatesLongitude" ]

  initialize(){
    this.initChosen()
  }

  connect(){
    this.data.set("active", this.isActive())
  }

  submitForm(){
    this.formTarget.submit()
  }

  // true si hay algún filtro activo
  isActive(){
    this.log("isActive")
    return this.filterFieldTargets.some(field => {
      return this.fieldIsActive(field)
    })
  }

  fieldIsActive(field){
    if (field.type === "checkbox") {
      return field.checked
    } else {
      return field.value.length > 0
    }
  }

  initChosen(){
    $(".chosen-select").chosen()
  }

  placeChanged(event){
    const value = event.target.value
    if (value === "near_me"){
      if (!navigator.geolocation){
        // no geolocation support, clean selection
        event.target.value = ""
        return
      }
      navigator.geolocation.getCurrentPosition((position) => {
        if (this.hasCoordinatesLatitudeTarget && this.hasCoordinatesLongitudeTarget){
          this.coordinatesLatitudeTarget.value = position.coords.latitude
          this.coordinatesLongitudeTarget.value = position.coords.longitude
        }
      }, () => {
        // on error, clear selection
        event.target.value = ""
      })
    } else {
      // clear coordinates when not using near_me
      if (this.hasCoordinatesLatitudeTarget && this.hasCoordinatesLongitudeTarget){
        this.coordinatesLatitudeTarget.value = ""
        this.coordinatesLongitudeTarget.value = ""
      }
    }
  }

  log(msg){
    //console.log("[filters] " + msg)
  }

}
